<!-- Background dinamico da environment — nessun riferimento hardcoded a polipush/plusdigital -->
<div class="al-host-bg" [style.backgroundImage]="backgroundImageStyle">

<!-- ═══════════════════════════════════════════════════════════════════════════
     MODALE CARICAMENTO / ERRORE
════════════════════════════════════════════════════════════════════════════ -->
<div class="al-overlay" *ngIf="isLoading">
  <!--
    Classe --dark attivata quando brandLogoOnDark è true (es. plusdigital).
    Il logo plusdigital è bianco su trasparente: senza sfondo scuro sarebbe invisibile.
  -->
  <div class="al-loading-modal" [class.al-loading-modal--dark]="brandLogoOnDark">

    <ng-container *ngIf="!loadingError; else errorTmpl">

      <img
        [src]="brandLogoSrc"
        alt="Logo"
        class="al-loading-logo"
      />

      <div class="al-loading-spinner-wrap">
        <mat-spinner diameter="52" strokeWidth="4"></mat-spinner>
      </div>

      <div class="al-loading-text-wrap">
        <p class="al-loading-title">Verifica in corso</p>
        <p class="al-loading-subtitle">Stiamo verificando il tuo accesso, attendere prego...</p>
      </div>

    </ng-container>

    <ng-template #errorTmpl>

      <div class="al-loading-error-icon-wrap">
        <mat-icon class="al-error-icon">link_off</mat-icon>
      </div>

      <div class="al-loading-text-wrap">
        <p class="al-loading-title al-loading-title--error">Accesso non riuscito</p>
        <p class="al-loading-subtitle">{{ loadingError }}</p>
      </div>

    </ng-template>

  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════════════
     MODALE TIMEOUT SESSIONE
════════════════════════════════════════════════════════════════════════════ -->
<div class="al-overlay" *ngIf="sessionExpired">
  <div class="al-loading-modal">

    <div class="al-loading-error-icon-wrap al-loading-error-icon-wrap--timeout">
      <mat-icon class="al-error-icon al-error-icon--timeout">timer_off</mat-icon>
    </div>

    <div class="al-loading-text-wrap">
      <p class="al-loading-title al-loading-title--error">Sessione scaduta</p>
      <p class="al-loading-subtitle">Il tempo a disposizione è terminato.<br />Richiedi un nuovo link di accesso.</p>
    </div>

  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════════════
     MODALE CONFERMA INVIO DOCUMENTO
════════════════════════════════════════════════════════════════════════════ -->
<div class="al-overlay" *ngIf="showUploadConfirm">
  <div class="al-confirm-modal">

    <div class="al-confirm-icon-wrap">
      <mat-icon class="al-confirm-icon">upload_file</mat-icon>
    </div>

    <div class="al-loading-text-wrap">
      <p class="al-loading-title">Conferma invio</p>
      <p class="al-loading-subtitle">
        Stai per inviare il file:<br />
        <strong>{{ selectedFile?.name }}</strong><br /><br />
        Vuoi procedere?
      </p>
    </div>

    <div class="al-confirm-actions">

      <button
        mat-stroked-button
        class="al-confirm-btn al-confirm-btn--cancel"
        (click)="cancelUpload()"
      >
        Annulla
      </button>

      <button
        mat-raised-button
        color="primary"
        class="al-confirm-btn al-confirm-btn--confirm"
        (click)="confirmUpload()"
      >
        <mat-icon>send</mat-icon>
        Invia
      </button>

    </div>

  </div>
</div>

<!-- ═══════════════════════════════════════════════════════════════════════════
     CONTENUTO PAGINA
════════════════════════════════════════════════════════════════════════════ -->
<ng-container *ngIf="!isLoading && authResponse && !loadingError">

  <div class="al-page">

    <!-- ── Header ──────────────────────────────────────────────────────────── -->
    <div class="al-header">

      <div class="al-header-brand">
        <img
          *ngIf="companyLogoSrc"
          [src]="companyLogoSrc"
          alt="Logo azienda"
          class="al-logo"
        />
      </div>

      <div class="al-timer" [class.al-timer--warning]="isTimerWarning">
        <div class="al-timer-inner">
          <div class="al-timer-top">
            <mat-icon class="al-timer-icon">schedule</mat-icon>
            <span class="al-timer-label">
              {{ remainingMinutesFormatted }}:{{ remainingSecondsFormatted }}
            </span>
          </div>
          <span class="al-timer-sublabel" *ngIf="!isTimerWarning">Tempo rimanente</span>
          <span class="al-timer-sublabel al-timer-sublabel--warning" *ngIf="isTimerWarning">
            Sessione in scadenza
          </span>
        </div>
      </div>

    </div>

    <!-- ── Griglia download ────────────────────────────────────────────────── -->
    <div
      class="al-downloads-grid"
      [class.al-downloads-grid--many]="authResponse.Downloads.length >= 5"
    >

      <div
        class="al-download-card"
        *ngFor="let item of authResponse.Downloads"
        (click)="openDownload(item)"
        role="button"
        tabindex="0"
        (keyup.enter)="openDownload(item)"
        [attr.aria-label]="'Scarica ' + item.Filename"
      >

        <div class="al-download-icon-wrap" [class]="'al-download-icon-wrap--' + getFileIconClass(item.Type)">
          <mat-icon class="al-download-icon">{{ getFileIcon(item.Type) }}</mat-icon>
        </div>

        <span class="al-download-filename">{{ item.Filename }}</span>
        <span class="al-download-description">{{ item.Description }}</span>

        <div class="al-download-action">
          <mat-icon class="al-download-action-icon">download</mat-icon>
          <span class="al-download-action-label">Scarica</span>
        </div>

      </div>

    </div>

    <!-- ── Area upload (condizionale) ─────────────────────────────────────── -->
    <div class="al-upload-section" *ngIf="authResponse.Upload">

      <div class="al-upload-header">
        <mat-icon class="al-upload-icon">cloud_upload</mat-icon>
        <div>
          <p class="al-upload-title">Carica un documento</p>
          <p class="al-upload-subtitle">Seleziona un file PDF da inviare (max 1 file)</p>
        </div>
      </div>

      <label
        for="access-link-file-input"
        class="al-upload-label"
        [class.al-upload-label--drag-over]="isDragOver"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        <mat-icon class="al-upload-label-icon">attach_file</mat-icon>
        <span *ngIf="!selectedFile && !isDragOver">Trascina qui un PDF oppure clicca per selezionarlo</span>
        <span *ngIf="!selectedFile && isDragOver">Rilascia il file per caricarlo</span>
        <span *ngIf="selectedFile">{{ selectedFile.name }}</span>
      </label>

      <input
        id="access-link-file-input"
        type="file"
        accept="application/pdf"
        class="al-upload-input"
        (change)="onFileSelected($event)"
      />

      <button
        mat-raised-button
        color="primary"
        class="al-upload-btn"
        [disabled]="!selectedFile || isUploading"
        (click)="onUploadRequest()"
      >
        <mat-spinner *ngIf="isUploading" diameter="20" class="al-upload-spinner"></mat-spinner>
        <mat-icon *ngIf="!isUploading">send</mat-icon>
        <span *ngIf="!isUploading">Invia documento</span>
      </button>

    </div>

  </div>

</ng-container>

</div><!-- /al-host-bg -->
